import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            bgcolor="#f5f7fa"
            px={2}
            textAlign="center"
        >
            <Typography variant="h1" fontWeight="bold" color="#4a5568" fontSize={{ xs: "6rem", md: "8rem" }}>
                404
            </Typography>
            <Typography variant="h5" color="#6c757d" mb={2}>
                Oops! Page not found
            </Typography>
            <Typography variant="body1" color="#6c757d" maxWidth="400px" mb={4}>
                The page you're looking for doesn’t exist or you don’t have permission to access it.
            </Typography>
            {/* <Button
                variant="contained"
                color="primary"
                onClick={() => navigate("/")}
                sx={{
                    borderRadius: "2xl",
                    textTransform: "none",
                    px: 4,
                    py: 1.5,
                    fontSize: "1rem",
                    boxShadow: 3
                }}
            >
                Go to Home
            </Button> */}
        </Box>
    );
};

export default NotFound;
